import { render, staticRenderFns } from "./newstudy-in.vue?vue&type=template&id=d4e6017e&lang=pug&"
import script from "./newstudy-in.vue?vue&type=script&lang=js&"
export * from "./newstudy-in.vue?vue&type=script&lang=js&"
import style0 from "./newstudy-in.vue?vue&type=style&index=0&id=d4e6017e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports